import { render, staticRenderFns } from "./DashboardRankings.vue?vue&type=template&id=3d45759a"
import script from "./DashboardRankings.vue?vue&type=script&lang=js"
export * from "./DashboardRankings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports